// 通用头部混入
export default {
  data() {
    return {
      // 导航是否冻结
      headerFreeze: false,
      // header_box 高度
      headerHightInfo: {
        // 默认
        default: 36 + 94 + 40,
        // 冻结
        freeze: 36,
      },
      // 当前页面名称
      pageName: '',
    }
  },
  computed: {
    headerHight() {
      return !this.headerFreeze ? this.headerHightInfo.default : this.headerHightInfo.freeze
    },
  },
  watch: {
    $route({ name }) {
      this.pageName = name
    },
  },
  mounted() {
    if (this.defaultHeaderFreeze) {
      this.headerFreeze = true
    } else {
      this.$nextTick(() => {
        window && window.addEventListener('scroll', this.throttle(this.scrollDs, 100))
      })
    }
    this.pageName = this.$route.name
  },
  destroyed() {
    window && window.removeEventListener('scroll', this.scrollDs)
  },
  methods: {
    // 页面滚动事件
    scrollDs() {
      this.headerFreeze = document.documentElement.scrollTop > 190
    },
    throttle(func, delay) {
      let timer = null
      let startTime = Date.now()
      return function () {
        const curTime = Date.now()
        const remaining = delay - (curTime - startTime)
        const context = this
        const args = arguments
        clearTimeout(timer)
        if (remaining <= 0) {
          func.apply(context, args)
          startTime = Date.now()
        } else {
          timer = setTimeout(func, remaining)
        }
      }
    },
  },
}
